'use strict';/* global define */define('modules/users/directives/user-list/controller',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     controller.$inject = ["$scope"];
function controller($scope){// jshint validthis:true
// jshint latedef:false
var ctrl=this;ctrl.close=closeIt;// ---
/**
     * Close/delete a user from the list
     *
     * @param  {Object} ev   - triggered event
     * @param  {Object} user - user of the user-list-user
     * @return {Object}      - return of the parent scope function
     *                         -> preferably a pending
     *                            request to react to it
     *
     * @tested
     */function closeIt(ev,user){return $scope.close(ev,user,$scope.list);}}module.exports=controller;});
